export const API_EXTERNAL_ENDPOINT = 'cottages/:id/rent-units-structure'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/cottages/rent-units-structure'
